/* One canonical paper theme — dark mode retired with the ink & gold redesign. */
import { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext({ mode: 'light', toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    try { localStorage.removeItem('lumyn-theme'); } catch { /* noop */ }
  }, []);
  return (
    <ThemeContext.Provider value={{ mode: 'light', toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
